














// import $ from 'jquery';
export default {
    name: 'App',
    created() {
        window.addEventListener('storage', (res) => {
            if (res.key === 'id') {
                this.$router.push('/Login');
            }
        });
    },
    mounted() {
        // this.bodyScale();
        // if (this.myBrowser() != 'Chrome') {
        //     $('body').css({
        //         overflow: 'hidden',
        //     });
        // }
        // window.onresize = () => {
        //     this.bodyScale();
        // };
    },
    methods: {
        bodyScale() {
            var devicewidth = document.documentElement.clientWidth;
            var scale: any = devicewidth / 1920;
            if (this.myBrowser() === 'Chrome') {
                (document as any).body.style.zoom = scale;
            } else {
                $('body').css({
                    transform: `scale(${scale})`,
                    '-moz-transform-origin': 'left top',
                });
            }
        },
        myBrowser() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf('Opera') > -1;
            if (isOpera) {
                return 'Opera';
            } //判断是否Opera浏览器
            if (userAgent.indexOf('Firefox') > -1) {
                return 'Firefox';
            } //判断是否Firefox浏览器
            if (userAgent.indexOf('Chrome') > -1) {
                return 'Chrome';
            }
            if (userAgent.indexOf('Safari') > -1) {
                return 'Safari';
            } //判断是否Safari浏览器
            if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
                return 'IE';
            } //判断是否IE浏览器
        },
    },
};
